<template>
    <section>
        <!-- 検索窓 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                    <el-date-picker type="date"
                                    placeholder="年月日"
                                    format="yyyy-MM-dd"
                                    v-model="filters.date">
                    </el-date-picker>
                <el-form-item>
                    <el-button type="primary" v-on:click="getViews">検索</el-button>
                    <a class="el-button el-button--primary" :href="blobUrl" download="view_log.csv">CSV</a>
                </el-form-item>
            </el-form>
        </el-col>
        <!-- /検索窓 -->

        <!-- リスト -->
        <el-table :data="views" highlight-current-row v-loading="listLoading" @selection-change="selsChange"
                  style="width: 100%;">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="user.name" label="店舗名" width="200">
            </el-table-column>
            <el-table-column prop="sessionId" label="セッションID" width="350">
            </el-table-column>
            <el-table-column prop="content.name" label="コンテンツ名" width="400">
            </el-table-column>

            <el-table-column prop="vtkt" label="VTKT" width="200">
            </el-table-column>

            <el-table-column label="視聴開始時間" width="210" sortable>
                <template scope="scope">
                    {{ scope.row.createdAt | formatDate }}
                </template>
            </el-table-column>
        </el-table>
        <!-- /リスト -->

    </section>
</template>

<script>
    import util from '../../common/js/util'
//    import * as Request from '../../api/content';
    import * as ViewsRequest from '../../api/view';
    import ElOption from "../../../node_modules/element-ui/packages/select/src/option.vue";
    import * as AWS from "aws-sdk";
    import moment from "moment";
    import config from "../../config/app";
    import { getCredentials } from "../../api/session";
    import { formatDate } from "../../components/filters/format";

    export default {
        components: { ElOption },
        filters: { formatDate },
        data() {
            return {
                filters: {
                    date: null//moment().format("YYYY-MM-DD")
                },
                views: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [],
                config: config,
                blobUrl: ""
            }
        },
        computed: {
            year() {
                return moment(this.filters.date).years();
            },
            month() {
                return moment(this.filters.date).months() + 1;
            },
            day() {
                return moment(this.filters.date).dates()
            }
        },
        methods: {
            
            getAllViews() {
                let params = {
                    params: {
                        year: this.year,
                        month: this.month,
                        day: this.day,
                    }
                };
                ViewsRequest
                    .search(params)
                    .then(res => {
                        this.views = res.data;
                        this.listLoading = false;
                        this.createCsv();
                    });
            },
            getViews() {
                let params = {
                    params: {
                        year: this.year,
                        month: this.month,
                        day: this.day,
                    }
                };
//console.log(this.filters.date);
//console.log(this.month);
//console.log(this.day);
                if (!this.filters.date) {
                    ViewsRequest
                        .search(params)
                        .then(res => {
                            this.views = res.data;
                            this.listLoading = false;
                            this.createCsv();
                        });
                } else {
                    ViewsRequest
                        .searchMonthlyDay(params)
                        .then(res => {
                            this.views = res.data;
                            this.listLoading = false;
                            this.createCsv();
                        });
                }
//                this.listLoading = true;
//                console.log(params);
/**
                ViewsRequest.count()
                    .then(res => {
                        this.total = res.data.count;
                        
console.log(res);
                    });
/**
                ViewsRequest
                    .search(params)
                    .then(res => {
                        this.views = res.data;
                        this.listLoading = false;

                        this.createCsv();
                    });
/**/

/*********/

/*********/

/**
                ViewsRequest
                    .all(params)
                    .then(res => {
                        this.views = res.data;
                        this.listLoading = false;

                        this.createCsv();
                    });
/**/
            },
            createCsv() {
                const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);

                const columns = ["店舗ID", "店舗名", "セッションID", "コンテンツID", "コンテンツ名", "ステータス", "VTKT", "視聴開始時間"];
                const header = columns.join(',') + '\n';

                const body = this.views.map(view => {
                    return [
                        view.user.id,
                        view.user.name,
                        view.sessionId,
                        view.content.id,
                        view.content.name,
                        view.vtkt,
                        moment(view.createdAt).format("YYYY/MM/DD HH:mm")
                    ];
                }).join('\n');

                const blob = new Blob([ bom, header + body ], { "type" : "text/csv" });
                this.blobUrl = window.URL.createObjectURL(blob);

            },
            selsChange: function (sels) {
                this.sels = sels;
            },
        },
        mounted() {
            this.getViews();
            this.getAllViews();
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// View.vue?4d8c6d1e